module.exports = __webpack_public_path__ + "roi-sweden.5114607f72c07f23aaec.jpg";